/*
Copyright 2020 SMART Methodology
Copyright 2019 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

NOTICE: THIS FILE HAS BEEN MODIFIED BY SMART Methodology UNDER COMPLIANCE WITH THE
APACHE 2.0 LICENCE FROM THE ORIGINAL WORKOF THE COMPANY ODK Central. THE FOLLOWING
IS THE COPYRIGHT OF THE ORIGINAL DOCUMENT:

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
*/
import Vue from 'vue';



// Importing setup.js first, because other import statements below may import
// some of the same modules as setup.js, and in some cases, the order in which
// setup.js imports modules matters.
import * as VueCookie from 'vue-cookie';
import VueTour from 'vue-tour';
import VueGtag from 'vue-gtag';
import './handsontable';
import setup from './setup';
import App from './components/app.vue';
import router from './router';
import store from './store';
import { i18n, loadLanguageAsync } from './localization';
import 'vue-tour/dist/vue-tour.css';
import 'handsontable/dist/handsontable.full.min.css';
import { getLocale } from './util/util';

// load the cookie plugin to the vue environment
setup(Vue);
Vue.use(VueCookie);
Vue.use(VueTour);
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GOOGLE_TAG_KEY,
    appName: 'Smart Platform',
    params: {
      send_page_view: true
    }
  }
});
loadLanguageAsync(getLocale()).then(_ => new Vue({ // eslint-disable-line no-new
  el: '#app',
  i18n,
  render: (h) => h(App),
  router,
  store
}));

